import React, { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TopCategoryOuter from "../TopCategoryOuter"
import TumiorosisakiService from "../../../service/master/tumiorosisaki/tumiorosisakiService"
import { TTumiorosisakiListGetRes } from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import { NewTumiorosisakiGrid } from "./NewTumiorosisakiGrid"
import _ from "lodash"

const NewTumiorosisakiList = () => {
  const [searchStart, setSearchStart] = useState(false)
  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  const [当月登録積卸先List, set当月登録積卸先List] = useState<
    (TTumiorosisakiListGetRes & {
      積卸先地?: string
    })[]
  >()

  const searchFunction = useCallback(async () => {
    const 積卸先Res = await new TumiorosisakiService().getList({
      最新更新順表示フラグ: true,
      登録年月検索フラグ: true,
      登録年月: 営業日,
    })

    const list = _.orderBy(
      積卸先Res?.data?.map((e) => ({
        ...e,
        積卸先地: `${e.住所１ ?? ""}${e.住所２ ?? ""}`,
      })),
      ["作成日時"],
      ["desc"]
    )
    set当月登録積卸先List([...list])

    setSearchStart(false)
  }, [営業日])

  useEffect(() => {
    setSearchStart(true)
  }, [])

  return (
    <div>
      <div className="topLabel2">今月の積地・卸地マスタ 新規登録情報</div>
      <TopCategoryOuter
        searchFunction={searchFunction}
        searchStartFlag={searchStart}>
        <NewTumiorosisakiGrid
          tumiorosisakiList={当月登録積卸先List}></NewTumiorosisakiGrid>
      </TopCategoryOuter>
    </div>
  )
}

export default NewTumiorosisakiList
